"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = void 0;
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const pretty_loader_1 = require("../../../pretty-loader");
const Button = ({ text, variant, className, isVisible, focus, size, disabled, onClick, loading, prettyLoaderConfig, }) => {
    if (!isVisible) {
        return null;
    }
    const ref = (0, react_1.useRef)();
    (0, react_1.useEffect)(() => {
        if (focus) {
            ref.current.focus();
        }
    }, []);
    return (react_1.default.createElement(pretty_loader_1.PrettyLoaderReact, { isLoading: loading, disabled: disabled && !loading, ref: ref, config: Object.assign({ color: '#E4F0FC' }, prettyLoaderConfig) },
        react_1.default.createElement("button", { type: "button", className: (0, classnames_1.default)(`btn btn-${variant} ${className} flex-sm-grow-0 flex-grow-1`, { [`btn-${size}`]: size }), onClick: (e) => {
                e.stopPropagation();
                e.preventDefault();
                onClick();
            } }, text)));
};
exports.Button = Button;
